import Button from "@material-ui/core/Button";
import { Link as MuiLink } from "@material-ui/core";
import { LockOutlined } from "@material-ui/icons";
import { Link } from "react-router-dom";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";

function Forbidden() {
  return (
    <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <ImageWithText
        align="center"
        title="403 - Access denied"
        subheader="You don't have permission to view this page."
        image={<LockOutlined style={{ fontSize: 120, color: "#d0d0d0" }} />}
        action={
          <MuiLink component={Link} underline="none" to="/">
            <Button color="secondary" variant="outlined">
              Go home
            </Button>
          </MuiLink>
        }
      />
    </div>
  );
}

export default Forbidden;
